import { useEffect } from 'react';
import { ActionCreator as AuthActionCreator } from '../../context/AuthProvider';
import { AuthStatus } from '../../utilities/constants/common';
import { useAuthContext } from './useAuthContext';
import { useUserData } from './useUserData';

export const useAuthorization = () => {
  const { authDispatch } = useAuthContext();
  const { data: userData } = useUserData();

  useEffect(() => {
    if (userData) {
      authDispatch(AuthActionCreator.setUserData(userData));
    }
    authDispatch(AuthActionCreator.setAuthStatus(AuthStatus.PASSED));
  }, [authDispatch, userData]);
};
